import * as XLSX from 'xlsx'
import moment from 'moment'
import {ICommissionRate} from '../../types/carriers'

const ALL_STATES_LABEL = 'All States'

const toNumber = (value: string | number) => {
  const parsedValue = Number(value)
  return Number.isFinite(parsedValue) ? parsedValue : null
}

const sanitizeFileName = (value: string) =>
  value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')

export const exportCommissionRatesToExcel = (
  commissionRates: ICommissionRate[],
  carrierName?: string
) => {
  const rows = commissionRates.map((commissionRate) => ({
    Carrier: commissionRate.carrier?.name || carrierName || '',
    State: commissionRate.stateEU?.name || ALL_STATES_LABEL,
    'New Rate': toNumber(commissionRate.rateNew),
    'Renewal Rate': toNumber(commissionRate.rateRenew),
    Created: moment(commissionRate.created).format('YYYY-MM-DD'),
  }))

  const worksheet = XLSX.utils.json_to_sheet(rows, {
    header: ['Carrier', 'State', 'New Rate', 'Renewal Rate', 'Created'],
  })

  worksheet['!cols'] = [{wch: 32}, {wch: 22}, {wch: 14}, {wch: 16}, {wch: 12}]
  worksheet['!autofilter'] = {ref: `A1:E${Math.max(rows.length + 1, 1)}`}

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Commission Rates')

  const carrierSuffix = carrierName ? `-${sanitizeFileName(carrierName)}` : '-all-carriers'
  XLSX.writeFile(workbook, `commission-rates${carrierSuffix}-${moment().format('YYYY-MM-DD')}.xlsx`)
}
